import { RemoteGetSuspectedManipulation } from 'data/usecases';
import { GetSuspectedManipulationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlSuspectedManipulation } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetSuspectedManipulation =
  (): GetSuspectedManipulationUseCaseInterface =>
    new RemoteGetSuspectedManipulation(
      makeApiUrlSuspectedManipulation(),
      makeAxiosHttpClient(),
    );
